import React from "react";
import { Form, Table } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "state/hooks";
import { 
  setAppConfig, 
  getAppConfig,
  APP_CONFIG_OVERRIDES_LOCAL_STORAGE_KEY,
  AppConfig,
  defaultAppConfig
} from "state/slices/app-config-slice";

const AppConfigManager: React.FC = () => {
  const dispatch = useAppDispatch();
  const appConfig = useAppSelector(getAppConfig);

  const handleToggleConfig = (key: keyof AppConfig, value: boolean) => {
    const newConfig = { [key]: value };
    dispatch(setAppConfig(newConfig));
    
    const currentOverrides = localStorage.getItem(APP_CONFIG_OVERRIDES_LOCAL_STORAGE_KEY);
    const parsedOverrides = currentOverrides ? JSON.parse(currentOverrides) : {};
    localStorage.setItem(APP_CONFIG_OVERRIDES_LOCAL_STORAGE_KEY, JSON.stringify({ ...parsedOverrides, ...newConfig }));
  };

  const renderConfigRow = (key: keyof AppConfig) => {
    const value = appConfig[key];
    
    return (
      <tr key={key}>
        <td><code>{key}</code></td>
        <td style={{ textAlign: "center" }}>
          <Form.Check
            type="switch"
            id={`config-switch-${key}`}
            checked={!!value}
            onChange={(e) => handleToggleConfig(key, e.target.checked)}
          />
        </td>
      </tr>
    );
  };

  return (
    <Table striped bordered hover responsive size="sm">
      <thead>
        <tr>
          <th>Config Key</th>
          <th style={{ width: "100px", textAlign: "center" }}>Enabled</th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(defaultAppConfig).map((key) => renderConfigRow(key as keyof AppConfig))}
      </tbody>
    </Table>
  );
};

export default AppConfigManager;